import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Truck, ChevronDown, ChevronUp } from "lucide-react";

// ===== Données =====
const cityLink = (label, to) => (
  <Link
    to={to}
    className="font-semibold text-[#237cb5] underline underline-offset-2 hover:text-[#1a5d8a] transition-colors"
  >
    {label}
  </Link>
);

const DEPARTEMENTS_DETAILS = [
  {
    code: "75",
    title: "Déménagement Paris 75",
    hub: "/demenagement-paris-75",
    desc: (
      <>
        Intervention rapide intra-muros : stationnement réglementé, autorisations de voirie et
        monte-meubles pour les étages sans ascenseur. Nos équipes déménagent chaque semaine le{" "}
        {cityLink("15e arrondissement", "/demenagement-paris-15e-arrondissement")}, le{" "}
        {cityLink("16e arrondissement", "/demenagement-paris-16e-arrondissement")} et le{" "}
        {cityLink("11e arrondissement", "/demenagement-paris-11e-arrondissement")}, les immeubles
        haussmanniens du {cityLink("8e arrondissement", "/demenagement-paris-8e-arrondissement")}{" "}
        comme les pentes de Montmartre dans le{" "}
        {cityLink("18e arrondissement", "/demenagement-paris-18e-arrondissement")} — et tous les
        autres quartiers de la capitale.
      </>
    ),
  },
  {
    code: "77",
    title: "Déménagement Seine-et-Marne 77",
    hub: "/demenagement-seine-et-marne-77",
    desc: (
      <>
        Du pavillon en zone périurbaine aux grandes propriétés rurales, nos équipes couvrent
        l&apos;ensemble du département. Intervention à{" "}
        {cityLink("Meaux", "/demenagement-meaux")},{" "}
        {cityLink("Melun", "/demenagement-melun")},{" "}
        {cityLink("Chelles", "/demenagement-chelles")},{" "}
        {cityLink("Pontault-Combault", "/demenagement-pontault-combault")},{" "}
        {cityLink("Bussy-Saint-Georges", "/demenagement-bussy-saint-georges")} et jusqu&apos;à{" "}
        {cityLink("Fontainebleau", "/demenagement-fontainebleau")}, avec une logistique pensée
        pour les distances de la grande couronne.
      </>
    ),
  },
  {
    code: "78",
    title: "Déménagement Yvelines 78",
    hub: "/demenagement-yvelines-78",
    desc: (
      <>
        Entre zones résidentielles et grandes maisons avec jardin, une organisation adaptée
        aux longues distances internes au département. Intervention à{" "}
        {cityLink("Versailles", "/demenagement-versailles")},{" "}
        {cityLink("Saint-Germain-en-Laye", "/demenagement-saint-germain-en-laye")},{" "}
        {cityLink("Poissy", "/demenagement-poissy")},{" "}
        {cityLink("Sartrouville", "/demenagement-sartrouville")},{" "}
        {cityLink("Mantes-la-Jolie", "/demenagement-mantes-la-jolie")} et jusqu&apos;à{" "}
        {cityLink("Rambouillet", "/demenagement-rambouillet")}.
      </>
    ),
  },
  {
    code: "91",
    title: "Déménagement Essonne 91",
    hub: "/demenagement-essonne-91",
    desc: (
      <>
        Pour particuliers et entreprises, d&apos;Évry à Massy en passant par Palaiseau,
        Savigny-sur-Orge et les zones pavillonnaires du sud parisien. Moyens adaptés aux
        grands volumes comme aux petits studios.
      </>
    ),
  },
  {
    code: "92",
    title: "Déménagement Hauts-de-Seine 92",
    hub: "/demenagement-hauts-de-seine-92",
    desc: (
      <>
        Département dense où stationnement et accès aux immeubles récents demandent une vraie
        expertise logistique. Intervention à{" "}
        {cityLink("Neuilly", "/demenagement-neuilly-sur-seine")},{" "}
        {cityLink("Boulogne", "/demenagement-boulogne-billancourt")},{" "}
        {cityLink("Levallois", "/demenagement-levallois-perret")},{" "}
        {cityLink("Courbevoie", "/demenagement-courbevoie")},{" "}
        {cityLink("Puteaux", "/demenagement-puteaux")},{" "}
        {cityLink("Rueil", "/demenagement-rueil-malmaison")},{" "}
        {cityLink("Issy-les-Moulineaux", "/demenagement-issy-les-moulineaux")} et dans tout
        le 92.
      </>
    ),
  },
  {
    code: "93",
    title: "Déménagement Seine-Saint-Denis 93",
    hub: "/demenagement-seine-saint-denis-93",
    desc: (
      <>
        Tous types de logements et locaux professionnels, du grand ensemble au pavillon : une
        organisation flexible adaptée à la diversité des habitats du département, de{" "}
        {cityLink("Montreuil", "/demenagement-montreuil")} à{" "}
        {cityLink("Saint-Denis", "/demenagement-saint-denis")} en passant par{" "}
        {cityLink("Aulnay-sous-Bois", "/demenagement-aulnay-sous-bois")} et{" "}
        {cityLink("Noisy-le-Grand", "/demenagement-noisy-le-grand")}.
      </>
    ),
  },
  {
    code: "94",
    title: "Déménagement Val-de-Marne 94",
    hub: "/demenagement-val-de-marne-94",
    desc: (
      <>
        Entre proximité parisienne et zones résidentielles plus calmes, une logistique ajustée
        à chaque configuration, immeuble ancien ou résidence récente. Intervention à{" "}
        {cityLink("Créteil", "/demenagement-creteil")},{" "}
        {cityLink("Vincennes", "/demenagement-vincennes")},{" "}
        {cityLink("Saint-Maur-des-Fossés", "/demenagement-saint-maur-des-fosses")},{" "}
        {cityLink("Champigny-sur-Marne", "/demenagement-champigny-sur-marne")},{" "}
        {cityLink("Ivry-sur-Seine", "/demenagement-ivry-sur-seine")} et{" "}
        {cityLink("Maisons-Alfort", "/demenagement-maisons-alfort")}.
      </>
    ),
  },
  {
    code: "95",
    title: "Déménagement Val-d'Oise 95",
    hub: "/demenagement-val-d-oise-95",
    desc: (
      <>
        Du secteur de {cityLink("Cergy", "/demenagement-cergy")}-
        {cityLink("Pontoise", "/demenagement-pontoise")} aux communes plus rurales du nord
        francilien. Équipes rodées à {cityLink("Argenteuil", "/demenagement-argenteuil")},{" "}
        {cityLink("Franconville", "/demenagement-franconville")},{" "}
        {cityLink("Herblay-sur-Seine", "/demenagement-herblay-sur-seine")},{" "}
        {cityLink("Enghien-les-Bains", "/demenagement-enghien-les-bains")} et{" "}
        {cityLink("Sarcelles", "/demenagement-sarcelles")}, comme aux accès difficiles en zone
        semi-rurale.
      </>
    ),
  },
];

const VILLES_FRANCE = [
  { name: "Bordeaux", slug: "demenagement-paris-bordeaux" },
  { name: "Marseille", slug: "demenagement-paris-marseille" },
  { name: "Nice", slug: "demenagement-paris-nice" },
  { name: "Cannes", slug: "demenagement-paris-cannes" },
  { name: "Perpignan", slug: "demenagement-paris-perpignan" },
  { name: "Toulouse", slug: "demenagement-paris-toulouse" },
  { name: "Lille", slug: "demenagement-paris-lille" },
  { name: "Strasbourg", slug: "demenagement-paris-strasbourg" },
  { name: "Annecy", slug: "demenagement-paris-annecy" },
  { name: "Nantes", slug: "demenagement-paris-nantes" },
  { name: "Lyon", slug: "demenagement-paris-lyon" },
  { name: "Montpellier", slug: "demenagement-paris-montpellier" },
  { name: "Toulon", slug: "demenagement-paris-toulon" },
  { name: "La Rochelle", slug: "demenagement-paris-la-rochelle" },
  { name: "Caen", slug: "demenagement-paris-caen" },
  { name: "Nîmes", slug: "demenagement-paris-nimes" },
  { name: "Rennes", slug: "demenagement-paris-rennes" },
];

function paysAnchor(pays, i) {
  return i % 2 === 0
    ? `Déménagement IDF – ${pays}`
    : `Déménageur IDF vers ${pays}`;
}

const PAYS_INTERNATIONAL = [
  { pays: "Allemagne", code: "de", villes: "Berlin · Munich · Francfort", ue: true, slug: "demenagement-paris-allemagne" },
  { pays: "Espagne", code: "es", villes: "Madrid · Barcelone · Valence", ue: true, slug: "demenagement-paris-espagne" },
  { pays: "Portugal", code: "pt", villes: "Lisbonne · Porto", ue: true, slug: "demenagement-paris-portugal" },
  { pays: "Italie", code: "it", villes: "Milan · Rome · Turin", ue: true, slug: "demenagement-paris-italie" },
  { pays: "Belgique", code: "be", villes: "Bruxelles · Anvers · Liège", ue: true, slug: "demenagement-paris-belgique" },
  { pays: "Pays-Bas", code: "nl", villes: "Amsterdam · Rotterdam · La Haye", ue: true, slug: "demenagement-paris-pays-bas" },
  { pays: "Luxembourg", code: "lu", villes: "Luxembourg-Ville", ue: true, slug: "demenagement-paris-luxembourg" },
  { pays: "Suisse", code: "ch", villes: "Genève · Zurich · Lausanne", ue: false, slug: "demenagement-paris-suisse" },
  { pays: "Monaco", code: "mc", villes: "Monaco-Ville", ue: false, slug: "demenagement-paris-monaco" },
  { pays: "Corse", code: "fr", villes: "Ajaccio · Bastia · Porto-Vecchio", ue: true, slug: "demenagement-paris-corse" },
];

// ===== Composant =====
export default function ZonesInterventions() {
  const [showAllDepts, setShowAllDepts] = useState(false);
  const [showAllVilles, setShowAllVilles] = useState(false);
  const [showAllIntl, setShowAllIntl] = useState(false);
  return (
    <>
    <section
      data-testid="home-zones-interventions"
      className="py-12 sm:py-16 bg-[#f7fafc] border-y border-[#e6edf3]"
      aria-labelledby="home-zones-title"
    >
      <div className="bd-container">
        {/* ===== Intro principale ===== */}
        <div className="max-w-3xl">
          <span className="bd-eyebrow">Nos zones d&apos;intervention</span>
          <h2
            id="home-zones-title"
            className="bd-h2 mt-4 text-[26px] sm:text-[30px] lg:text-[36px]"
          >
            Déménagement en <span style={{ color: "#237cb5" }}>Île-de-France</span> :
            intervention dans les 8 départements
          </h2>
          <p className="mt-6 text-[15px] sm:text-base leading-[1.8] text-[#3a4a5a]">
            Big Déménagement accompagne particuliers et professionnels dans tous leurs projets
            de déménagement en Île-de-France. Nos équipes interviennent dans les{" "}
            <strong className="text-[#0f1d2b] font-semibold">8 départements franciliens</strong>,
            de Paris à la petite et la grande couronne, pour les déménagements
            d&apos;appartements, de maisons, ainsi que les transferts de bureaux et de locaux
            professionnels.
          </p>
          <p className="mt-4 text-[15px] sm:text-base leading-[1.8] text-[#3a4a5a]">
            Habitués aux contraintes propres à la région parisienne — circulation dense,
            difficultés de stationnement, étages sans ascenseur, accès étroits ou nécessité
            d&apos;un monte-meubles — nos déménageurs adaptent l&apos;organisation, le matériel
            et les effectifs à chaque intervention, pour un déménagement fluide et sans
            imprévu, quel que soit votre secteur en IDF.
          </p>
        </div>

        {/* ===== Sous-section 1 — Les 8 départements ===== */}
        <div className="mt-10 sm:mt-12">
          <ul
            data-testid="home-zones-idf-list"
            className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5"
          >
            {DEPARTEMENTS_DETAILS.map((d, i) => (
              <li key={d.code} className={i >= 3 && !showAllDepts ? "hidden sm:block" : ""}>
                <article
                  data-testid={`home-zones-dept-${d.code}`}
                  className="h-full rounded-2xl bg-white border border-[#e6edf3] p-5 sm:p-6 transition-[transform,box-shadow,border-color] hover:border-[#237cb5] hover:shadow-[0_20px_40px_-24px_rgba(35,124,181,0.45)] hover:-translate-y-0.5"
                >
                  <Link
                    to={d.hub}
                    data-testid={`home-zones-dept-${d.code}-link`}
                    className="group inline-flex items-center gap-2"
                  >
                    <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-[#eaf3fb] text-[#237cb5] text-[12px] font-extrabold shrink-0">
                      {d.code}
                    </span>
                    <h3 className="text-[15px] sm:text-base font-extrabold text-[#0f1d2b] group-hover:text-[#237cb5] transition-colors leading-snug">
                      {d.title}
                    </h3>
                    <ArrowRight
                      className="h-4 w-4 shrink-0 text-[#cfdbe6] group-hover:text-[#237cb5] group-hover:translate-x-0.5 transition-[transform,color]"
                      aria-hidden="true"
                    />
                  </Link>
                  <p className="mt-3 text-[13.5px] text-[#3a4a5a] leading-relaxed">{d.desc}</p>
                </article>
              </li>
            ))}
          </ul>

          <div className="mt-5 flex justify-center sm:hidden">
            <button
              type="button"
              data-testid="home-zones-idf-toggle"
              onClick={() => setShowAllDepts((v) => !v)}
              className="inline-flex items-center gap-1.5 rounded-full border border-[#cfdbe6] bg-white px-5 py-2.5 text-[13px] font-semibold text-[#237cb5] hover:border-[#237cb5] transition-colors"
            >
              {showAllDepts ? "Voir moins" : "Voir tous les départements"}
              {showAllDepts ? (
                <ChevronUp className="h-4 w-4" aria-hidden="true" />
              ) : (
                <ChevronDown className="h-4 w-4" aria-hidden="true" />
              )}
            </button>
          </div>
        </div>

      </div>
    </section>

    {/* ===== Section — National longue distance ===== */}
    <section
      id="demenagement-national"
      data-testid="home-zones-national"
      className="py-12 sm:py-16 bg-white"
      aria-labelledby="home-zones-national-title"
    >
      <div className="bd-container">
        <div className="max-w-3xl">
          <span className="bd-eyebrow">Longue distance</span>
          <h2
            id="home-zones-national-title"
            className="bd-h2 mt-4 text-[26px] sm:text-[30px] lg:text-[36px]"
          >
            Déménagement national{" "}
            <span style={{ color: "#237cb5" }}>longue distance</span> : départ
            d&apos;Île-de-France vers toute la France
          </h2>
          <p className="mt-6 text-[15px] sm:text-base leading-[1.8] text-[#3a4a5a]">
            Quitter l&apos;Île-de-France pour entamer un nouveau chapitre en province demande
            une logistique rigoureuse et un{" "}
            <strong className="text-[#0f1d2b] font-semibold">partenaire de confiance</strong>.
            Que vous changiez d&apos;appartement, de maison, ou que vous transfériez votre
            bureau ou local professionnel vers une autre région, notre service spécialisé en{" "}
            <Link
              to="/demenagement-longue-distance"
              data-testid="home-zones-ld-link"
              className="font-semibold text-[#237cb5] underline underline-offset-2 hover:text-[#1a5d8a] transition-colors"
            >
              déménagement longue distance
            </Link>{" "}
            au départ d&apos;Île-de-France vous garantit un acheminement sécurisé, ponctuel et
            parfaitement maîtrisé vers toutes les destinations françaises.
          </p>
          <p className="mt-4 text-[15px] sm:text-base leading-[1.8] text-[#3a4a5a]">
            Nos équipes organisent des trajets optimisés au départ de Paris et de toute
            l&apos;Île-de-France vers les principales métropoles et régions du territoire :
          </p>
        </div>

        <h3 className="mt-8 text-[15px] sm:text-base font-extrabold text-[#0f1d2b]">
          Nos destinations les plus demandées au départ d&apos;Île-de-France :
        </h3>

        <ul
          data-testid="home-zones-france-list"
          className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-7 gap-y-3"
        >
          {VILLES_FRANCE.map((v, i) => (
            <li key={v.slug} className={i >= 3 && !showAllVilles ? "hidden sm:block" : ""}>
              <Link
                to={`/${v.slug}`}
                data-testid={`home-zones-france-${v.slug}`}
                className="text-[14px] font-medium text-[#237cb5] underline underline-offset-4 decoration-[#bcd6e8] hover:decoration-[#237cb5] transition-colors"
              >
                Déménagement Île-de-France vers {v.name}
              </Link>
            </li>
          ))}
        </ul>

        <div className="mt-5 flex justify-center sm:hidden">
          <button
            type="button"
            data-testid="home-zones-france-toggle"
            onClick={() => setShowAllVilles((v) => !v)}
            className="inline-flex items-center gap-1.5 rounded-full border border-[#cfdbe6] bg-white px-5 py-2.5 text-[13px] font-semibold text-[#237cb5] hover:border-[#237cb5] transition-colors"
          >
            {showAllVilles ? "Voir moins" : "Voir plus de destinations nationales"}
            {showAllVilles ? (
              <ChevronUp className="h-4 w-4" aria-hidden="true" />
            ) : (
              <ChevronDown className="h-4 w-4" aria-hidden="true" />
            )}
          </button>
        </div>

        <p className="mt-8 text-[15px] sm:text-base leading-[1.8] text-[#3a4a5a] max-w-3xl">
          Quelle que soit la distance ou la région de destination, nous adaptons le volume du
          camion, l&apos;équipe et le planning à votre projet, avec un{" "}
          <strong className="text-[#0f1d2b] font-semibold">devis gratuit et personnalisé</strong>{" "}
          pour tout déménagement longue distance au départ d&apos;Île-de-France.
        </p>
      </div>
    </section>

    {/* ===== Section — International + CTA ===== */}
    <section
      data-testid="home-zones-international"
      className="py-12 sm:py-16 bg-[#f7fafc] border-y border-[#e6edf3]"
      aria-labelledby="home-zones-intl-title"
    >
      <div className="bd-container">
        {/* ===== Sous-section 3 — International ===== */}
        <div>
          <div className="max-w-3xl">
            <span className="bd-eyebrow">International</span>
            <h2
              id="home-zones-intl-title"
              className="bd-h2 mt-4 text-[26px] sm:text-[30px] lg:text-[36px]"
            >
              Déménagement{" "}
              <span style={{ color: "#237cb5" }}>international en Europe</span> : nos 10
              destinations phares
            </h2>
          </div>
          <p className="mt-6 text-[15px] sm:text-base leading-[1.8] text-[#3a4a5a] max-w-3xl">
            Franchir les frontières pour vous installer en Europe nécessite un{" "}
            <strong className="text-[#0f1d2b] font-semibold">
              savoir-faire logistique irréprochable
            </strong>{" "}
            et un accompagnement sur-mesure. Que vous soyez un particulier pour un changement
            d&apos;appartement ou de maison, ou un professionnel, nous organisons votre
            déménagement international de A à Z. Découvrez nos 10 destinations phares et
            profitez d&apos;un transport sécurisé, de formalités simplifiées et d&apos;une prise
            en charge globale pour un changement de pays en toute sérénité.
          </p>

          <ul
            data-testid="home-zones-intl-list"
            className="mt-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4"
          >
            {PAYS_INTERNATIONAL.map(({ pays, code, villes, ue, slug }, i) => (
              <li key={slug} className={i >= 4 && !showAllIntl ? "hidden sm:block" : ""}>
                <Link
                  to={`/${slug}`}
                  data-testid={`home-zones-intl-${slug}`}
                  className="group block rounded-2xl bg-white border border-[#e6edf3] p-4 hover:border-[#237cb5] hover:shadow-[0_14px_28px_-18px_rgba(35,124,181,0.5)] transition-[transform,box-shadow,border-color,background-color,color] hover:-translate-y-0.5"
                >
                  <div className="flex items-center justify-between">
                    <img
                      src={`/images/flags/${code}.svg`}
                      alt={`Drapeau ${pays}`}
                      loading="lazy"
                      decoding="async"
                      className="h-[22px] w-[33px] object-cover rounded-[5px] border border-[#e6edf3] shadow-[0_2px_6px_rgba(15,29,43,0.12)]"
                    />
                    <span
                      className={`text-[9.5px] font-bold uppercase tracking-[0.12em] px-1.5 py-0.5 rounded-full ${
                        ue
                          ? "bg-[#eaf3fb] text-[#237cb5] border border-[#cfdbe6]"
                          : "bg-[#fff1e5] text-[#FF7A00] border border-[#ffd7b3]"
                      }`}
                    >
                      {ue ? "UE" : "Hors UE"}
                    </span>
                  </div>
                  <h4 className="mt-3 text-[13px] font-extrabold text-[#0f1d2b] flex items-center gap-1.5 group-hover:text-[#237cb5] transition-colors leading-snug">
                    {paysAnchor(pays, i)}
                    <ArrowRight
                      className="h-3 w-3 shrink-0 text-[#cfdbe6] group-hover:text-[#237cb5] group-hover:translate-x-0.5 transition-[transform,color]"
                      aria-hidden="true"
                    />
                  </h4>
                  <p className="mt-1 text-[11.5px] text-[#5b6b7a] leading-snug">{villes}</p>
                </Link>
              </li>
            ))}
          </ul>

          <div className="mt-5 flex justify-center sm:hidden">
            <button
              type="button"
              data-testid="home-zones-intl-toggle"
              onClick={() => setShowAllIntl((v) => !v)}
              className="inline-flex items-center gap-1.5 rounded-full border border-[#cfdbe6] bg-white px-5 py-2.5 text-[13px] font-semibold text-[#237cb5] hover:border-[#237cb5] transition-colors"
            >
              {showAllIntl ? "Voir moins" : "Voir plus de destinations internationales"}
              {showAllIntl ? (
                <ChevronUp className="h-4 w-4" aria-hidden="true" />
              ) : (
                <ChevronDown className="h-4 w-4" aria-hidden="true" />
              )}
            </button>
          </div>
        </div>

        {/* ===== Closing CTA ===== */}
        <div
          data-testid="home-zones-closing"
          className="mt-12 sm:mt-14 rounded-2xl bg-white border-2 border-dashed border-[#cfdbe6] p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center gap-5 sm:gap-6"
        >
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#fff4e8] text-[#FF7A00] shrink-0">
            <Truck className="h-6 w-6" />
          </span>
          <div className="flex-1">
            <h3 className="text-base sm:text-lg font-extrabold text-[#0f1d2b]">
              Votre destination n&apos;apparaît pas ?
            </h3>
            <p className="mt-2 text-[13.5px] sm:text-[14px] text-[#3a4a5a] leading-relaxed">
              Nous étudions chaque projet sur mesure. Particulier ou professionnel, demandez votre{" "}
              <strong className="text-[#0f1d2b] font-semibold">devis gratuit</strong> — nous
              revenons vers vous rapidement avec une proposition adaptée.
            </p>
          </div>
          <Link
            to="/demande-de-devis"
            data-testid="home-zones-cta"
            className="h-11 sm:self-center inline-flex items-center justify-center gap-2 rounded-xl px-5 bg-[#FF7A00] hover:bg-[#E66E00] text-white text-[13.5px] font-semibold shadow-[0_14px_24px_-10px_rgba(255,122,0,0.55)] transition-colors whitespace-nowrap"
          >
            Devis gratuit
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
    </>
  );
}
